var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { VeHistogram } from "v-charts";
import { HomePageService } from '~/services/domain-service/home-page.service';
import ChartQueryForm from "~/components/dashboard/chart-query-form.vue";
var OuterRankList = /** @class */ (function (_super) {
    __extends(OuterRankList, _super);
    function OuterRankList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.outerDataSet = [];
        _this.outCaseModel = {
            dateDimension: 'WEEK',
            rankingType: 'PAYBACK_AMOUNT',
            overduePeriod: '',
            productName: '',
        };
        return _this;
    }
    OuterRankList.prototype.updateData = function () {
    };
    OuterRankList.prototype.mounted = function () {
        this.updateData();
    };
    __decorate([
        Dependencies(HomePageService)
    ], OuterRankList.prototype, "homePageService", void 0);
    OuterRankList = __decorate([
        Component({
            components: {
                VeHistogram: VeHistogram,
                ChartQueryForm: ChartQueryForm
            }
        })
    ], OuterRankList);
    return OuterRankList;
}(Vue));
export default OuterRankList;
